const ImageGallery=
    {
        trailers:{
            HighBedTrailers: [
              { image: require('../../../assets/gallery/Trailers/High bed trailer (10).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (11).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (12).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (13).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (14).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (15).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (16).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (17).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (18).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (19).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (2).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (20).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (21).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (22).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (23).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (24).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (3).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (4).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (5).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (6).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (7).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (8).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer (9).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer loaded with excavator (2).jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer loaded with excavator.jfif') },
              { image: require('../../../assets/gallery/Trailers/High bed trailer.jfif') },
              { image: require('../../../assets/gallery/Trailers/highbedTrailer_n1.jpeg') },
              { image: require('../../../assets/gallery/Trailers/highbedTrailer_n2.jpeg') }
            ],
            LowBedTrailers: [
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (1).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (10).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (2).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (3).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (4).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (5).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (6).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (7).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (8).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer (9).jfif') },
              { image: require('../../../assets/gallery/Trailers/Low bed trailer.jfif') }
            ],
            SemiLowBedTrailers: [
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (1).jfif') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (2).jfif') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (3).jfif') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (4).jfif') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (5).jfif') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (6).jpeg') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (7).jpeg') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer (8).jpeg') },
              { image: require('../../../assets/gallery/Trailers/Semi low bed trailer.jfif') }
            ],
            Pullers: [
              { image: require('../../../assets/gallery/Trailers/puller (2).jpeg') },
              { image: require('../../../assets/gallery/Trailers/puller.jpeg') }
            ],
        }, 
        cranes:{
          AllTerrainCranes: [
            { image: require('../../../assets/gallery/Cranes/All terrain crane (back view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (back view) 2.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (back view).jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (front view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (front view).jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (side view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (side view) 2.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (side view) 3.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (side view) 4.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane (side view).jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 10.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 11.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 12.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 13.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 14.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 15.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 16.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 2.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 3.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 4.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 5.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 6.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 7.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 8.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane 9.jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane(back view).jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane(side view).jfif') },
            { image: require('../../../assets/gallery/Cranes/All terrain crane.jfif') }
          ],
          ChainMountedCrawlerMountedCranes: [
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted  crane.jfif') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane (back view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane (back view).jpeg') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane (side view) 1.jpeg') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane (side view).jpeg') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane 2.jpeg') },
            { image: require('../../../assets/gallery/Cranes/Chain mounted crawler mounted crane 3.jfif') }
          ],
          Excavators: [
            { image: require('../../../assets/gallery/Cranes/Excavator 1.jpeg') },
            { image: require('../../../assets/gallery/Cranes/Excavator.jpeg') }
          ],
          FaranaCranes: [
            { image: require('../../../assets/gallery/Cranes/Farana crane.jpg') }
          ],
          MKCranes: [
            { image: require('../../../assets/gallery/Cranes/MK crane (side view).jpeg') },
            { image: require('../../../assets/gallery/Cranes/MK crane.jpeg') }
          ],
          Palfinger: [
            { image: require('../../../assets/gallery/Cranes/Palfinger 3.jpeg') },
            { image: require('../../../assets/gallery/Cranes/Palfinger.jpeg') }
          ],
          PickandCarryCranes: [
            { image: require('../../../assets/gallery/Cranes/Pick and carry hydraulic crane.jpeg') }
          ],
          TruckCranes: [
            { image: require('../../../assets/gallery/Cranes/Truck crane (back view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane (back view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane (front view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane (front view) 2.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane (front view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane (side view) 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane (side view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 10.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 11.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 12.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 13.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 14.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 2.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 3.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 4.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 5.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 6.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 7.jfif') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 8.jpeg') },
            { image: require('../../../assets/gallery/Cranes/Truck crane 9.jpeg') },
            { image: require('../../../assets/gallery/Cranes/Truck crane.jfif') }
          ]
        },
        axles:{
          Axles_with_ODC_Cargo: [
            {
              name: "Axles with ODC cargo",
              image: require("../../../assets/gallery/Axles/Axles with ODC cargo.jfif")
            },
            {
              name: "Hydraulic axle with axles carrying ODC load (front view)",
              image: require("../../../assets/gallery/Axles/Hydraulic axle with axles carrying ODC load (front view).jfif")
            },
            {
              name: "Hydraulic axle with ODC load (back view)",
              image: require("../../../assets/gallery/Axles/Hydraulic axle with ODC load (back view).jfif")
            },
            {
              name: "Hydraulic axles carrying ODC load",
              image: require("../../../assets/gallery/Axles/Hydraulic axles carrying ODC load.jfif")
            },
            {
              name: "Hydraulic axles carrying ODC load (1)",
              image: require("../../../assets/gallery/Axles/Hydraulic axles carrying ODC load(1).jfif")
            },
            {
              name: "Hydraulic axles with ODC load",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with ODC load.jfif")
            },
            {
              name: "Hydraulic axles with ODC load (1)",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with ODC load(1).jfif")
            },
            {
              name: "Hydraulic axles with ODC load and lashings",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with ODC load and lashings.jfif")
            },
            {
              name: "Volvo puller with axles carrying ODC load",
              image: require("../../../assets/gallery/Axles/Volvo puller with axles carrying ODC load.jfif")
            },
            {
              name: "Volvo puller with axles and ODC load (front view)",
              image: require("../../../assets/gallery/Axles/Volvo puller with axles and ODC load (front view).jfif")
            }
          ],
          Axles_with_Puller: [
            {
              name: "Hydraulic axle with puller carrying girder",
              image: require("../../../assets/gallery/Axles/Hydraulic axle with puller carrying girder.jfif")
            },
            {
              name: "Hydraulic axle with puller carrying girder (1)",
              image: require("../../../assets/gallery/Axles/Hydraulic axle with puller carrying girder(1).jfif")
            },
            {
              name: "Hydraulic axle with puller carrying steel girder (1)",
              image: require("../../../assets/gallery/Axles/Hydraulic axle with puller carrying steel girder(1).jfif")
            },
            {
              name: "Hydraulic axle with puller carrying steel girder",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with puller carrying steel girder.jfif")
            },
            {
              name: "Hydraulic axles with puller and load",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with puller and load.jfif")
            },
            {
              name: "Hydraulic axles with puller and ODC load",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with puller and ODC load.jfif")
            },
            {
              name: "Hydraulic axles with puller carrying a crane",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with Puller carrying a crane.jfif")
            },
            {
              name: "Hydraulic axles with puller carrying ODC load (1)",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with puller carrying ODC load(1).jfif")
            },
            {
              name: "Hydraulic axles with puller carrying an train engine",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with puller carrrying an train engine.jfif")
            },
            {
              name: "Hydraulic axles with puller with train engine as load",
              image: require("../../../assets/gallery/Axles/Hydraulic axles with puller with train engine as load.jfif")
            }
          ],
          Axles_Joined_Laterally: [
            {
              name: "Hydraulic axles joined laterally carrying ODC load",
              image: require("../../../assets/gallery/Axles/Hydraulic axles joined laterally carrying ODC load.jfif")
            },
            {
              name: "Hydraulic axles joined laterally carrying ODC load (1)",
              image: require("../../../assets/gallery/Axles/Hydraulic axles joined laterally carrying ODC load(1).jfif")
            }
          ]
        },  
        fork_man_lift:{
          forklift:[
            {
              name: "Forklift",
              image: require("../../../assets/gallery/forklifts/Forklift (1).jfif")
            },
            {
              name: " Forklift (back view)",
              image: require("../../../assets/gallery/forklifts/Forklift (back view).jfif")
            },
            {
              name: " Forklift (front view)",
              image: require("../../../assets/gallery/forklifts/Forklift (front view).jfif")
            },
            {
              name: " Forklift",
              image: require("../../../assets/gallery/forklifts/Forklift.jfif")
            },
            { image: require('../../../assets/gallery/Cranes/Forklift (back view).jpeg') },
            { image: require('../../../assets/gallery/Cranes/Forklift.jpeg') }
          ],
          Manlifts: [
            { image: require('../../../assets/gallery/Cranes/JLG manlift (side view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (back view)3.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (backview).jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (Dingli) (back view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (Dingli) (backview).jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (side view) 3.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (side view) 4.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift (side view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 1.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 10.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 11.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 16.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 17.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 4.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 5.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 6.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 7.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 8.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift 9.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift side view.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift(back view).jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift.jfif') },
            { image: require('../../../assets/gallery/Cranes/Manlift2.jfif') }
          ],
        },
        others:[
            {
              name: "All terrain crane",
              image: require("../../../assets/gallery/others/all terrain crane.jpeg")
            },
            {
              name: "All terrain crane 2",
              image: require("../../../assets/gallery/others/all terrain crane 2.jpeg")
            },
            {
              name: "Crawler crane",
              image: require("../../../assets/gallery/others/crawler crane.jfif")
            },
            {
              name: "Crawler crane 2",
              image: require("../../../assets/gallery/others/crawler crane 2.jpeg")
            },
            {
              name: "Crawler crane 3",
              image: require("../../../assets/gallery/others/crawler crane 3.jpeg")
            },
            {
              name: "Crawler mounted lattice boom crane",
              image: require("../../../assets/gallery/others/Crawler mounted lattice boom crane.jfif")
            },
            {
              name: "Crawler mounted chain mounted crane",
              image: require("../../../assets/gallery/others/crawler mounted chain mounted crane.jfif")
            },
            {
              name: "Farana crane",
              image: require("../../../assets/gallery/others/Farana crane.jpg")
            },
            {
              name: "MK crane",
              image: require("../../../assets/gallery/others/MK crane.jpeg")
            },
            {
              name: "MK crane 2",
              image: require("../../../assets/gallery/others/MK crane 2.jpeg")
            },
            {
              name: "Palfinger",
              image: require("../../../assets/gallery/others/palfinger.jpeg")
            },
            {
              name: "Palfinger 2",
              image: require("../../../assets/gallery/others/palfinger (2).jpeg")
            },
            {
              name: "Pick and carry crane",
              image: require("../../../assets/gallery/others/Pick and carry crane.png")
            },
            {
              name: "Pick and carry hydraulic crane",
              image: require("../../../assets/gallery/others/pick and carry hydraulic crane.jpeg")
            },
            {
              name: "Rough terrain cranes",
              image: require("../../../assets/gallery/others/rough terrain cranes.jfif")
            },
            {
              name: "Truck mounted crane",
              image: require("../../../assets/gallery/others/truck mounted crane.jfif")
            },
            {
              name: "Truck mounted crane (image 2)",
              image: require("../../../assets/gallery/others/truck mounted crane.jpg")
            },
            {
              name: "40 feet high bed",
              image: require("../../../assets/gallery/others/40 feet high bed.jfif")
            },
            {
              name: "60 feet trailer",
              image: require("../../../assets/gallery/others/60 feet trailer.jfif")
            },
            {
              name: "Low bed trailer",
              image: require("../../../assets/gallery/others/low bed trailer.jfif")
            },
            {
              name: "Low bed trailer 40 feet",
              image: require("../../../assets/gallery/others/low bed trailer 40 feet.jfif")
            },
            {
              name: "Lowbed trailer (alternate)",
              image: require("../../../assets/gallery/others/lowbed-trailer.jpg")
            },
            {
              name: "Double crown 60 feet",
              image: require("../../../assets/gallery/others/double crown 60 feet.jfif")
            },
            {
              name: "Double crown semi low bed",
              image: require("../../../assets/gallery/others/Double crown semi low bed.jfif")
            },
            {
              name: "Trailer 70 feet",
              image: require("../../../assets/gallery/others/trailer 70 feet.jfif")
            },
            {
              name: "Trailer 80 feet",
              image: require("../../../assets/gallery/others/trailer 80 feet.jpg")
            },
            {
              name: "Trailer high bed 2 axle",
              image: require("../../../assets/gallery/others/Trailer high bed 2 axle.jfif")
            },
            {
              name: "Trailer semi low bed 3 axle",
              image: require("../../../assets/gallery/others/Trailer semi low bed 3 axle.jfif")
            },
            {
              name: "Triple axle high bed trailer",
              image: require("../../../assets/gallery/others/triple axle high bed trailer.jfif")
            },
            {
              name: "Semi low bed 3 axle",
              image: require("../../../assets/gallery/others/semi low bed 3 axle.jpg")
            },
            {
              name: "Semi low bed",
              image: require("../../../assets/gallery/others/semi low bed.jpeg")
            },
            {
              name: "Forklift",
              image: require("../../../assets/gallery/others/Forklift.jfif")
            },
            {
              name: "Forklift 2",
              image: require("../../../assets/gallery/others/forklift.jpeg")
            },
            {
              name: "Forklift (alternate)",
              image: require("../../../assets/gallery/others/forklift (2).jpeg")
            },
            {
              name: "Excavator",
              image: require("../../../assets/gallery/others/excavator.jpeg")
            },
            {
              name: "Excavator 2",
              image: require("../../../assets/gallery/others/excavator 2.jpeg")
            },
            {
              name: "Jlg manLift 125 ft",
              image: require("../../../assets/gallery/others/Jlg manLift 125 ft.jfif")
            },
            {
              name: "Manlift",
              image: require("../../../assets/gallery/others/manlift.jfif")
            },
            {
              name: "Manlift (alternate)",
              image: require("../../../assets/gallery/others/manlift.jpg")
            },
            {
              name: "Hydraulic axles",
              image: require("../../../assets/gallery/others/Hydraulic axles.jfif")
            },
            {
              name: "Multi axle trailer",
              image: require("../../../assets/gallery/others/multi axle trailer.jfif")
            },
            {
              name: "Puller",
              image: require("../../../assets/gallery/others/puller.jpeg")
            },
            {
              name: "Puller (alternate)",
              image: require("../../../assets/gallery/others/puller (2).jpeg")
            },
            {
              name: "Axles",
              image: require("../../../assets/gallery/others/axles.png")
            },
            {
              name: "Axles set",
              image: require("../../../assets/gallery/others/Axles set.png")
            },
            {
              name: "Axles 6",
              image: require("../../../assets/gallery/others/axles 6.png")
            }
        ]                 
    }

export  {ImageGallery};